import WatchlistList from "../components/watchlist/watchlist-list.component";
import PipelineNotifications from "../components/watchlist/pipeline-notifications.component";
import PageBackdrop from "../components/ui/PageBackdrop";
import PageHeader from "../components/ui/PageHeader";

const WatchlistPage = () => {
  return (
    <>
      <style>{`
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        .wp-root {
          background: var(--bg);
          min-height: 100vh;
          font-family: var(--font-sans);
          color: var(--text-primary);
          position: relative;
        }

        .wp-inner {
          position: relative; z-index: 1;
          max-width: 720px; margin: 0 auto;
          padding: 52px 24px 80px;
        }

        /* ── Header ── */
        .wp-header {
          opacity: 0; animation: fadeUp 0.45s 0.05s ease forwards;
        }

        @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.25; } }

        /* ── Section label ── */
        .wp-section-label {
          font-family: var(--font-mono); font-size: 12px; color: var(--text-tertiary);
          text-transform: uppercase; letter-spacing: 0.12em;
          margin-bottom: 12px;
        }

        .wp-section {
          margin-bottom: 32px;
          opacity: 0; animation: fadeUp 0.45s ease forwards;
        }

        .wp-section:nth-child(1) { animation-delay: 0.12s; }
        .wp-section:nth-child(2) { animation-delay: 0.22s; }

        /* ── Watchlist panel ── */
        .wl-wrap {
          background: var(--surface-1);
          border: 1px solid var(--border-subtle);
          border-radius: 12px;
          overflow: hidden;
        }

        /* ── Add form ── */
        .wa-wrap {
          padding: 20px 20px 16px;
          border-bottom: 1px solid var(--border-subtle);
        }

        .wa-label {
          font-family: var(--font-mono); font-size: 12px; color: var(--text-tertiary);
          text-transform: uppercase; letter-spacing: 0.12em; margin-bottom: 12px;
        }

        .wa-row {
          display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
        }

        .wa-input-wrap { flex: 1; min-width: 120px; }

        .wa-input {
          width: 100%; background: var(--bg); border: 1px solid var(--border-subtle);
          border-radius: 8px; padding: 9px 14px;
          font-family: var(--font-mono); font-size: 14px; font-weight: 500;
          color: var(--text-primary); letter-spacing: 0.08em; text-transform: uppercase;
          outline: none; transition: border-color 0.2s, box-shadow 0.2s;
          caret-color: var(--accent);
        }

        .wa-input:focus {
          border-color: rgba(52,211,153,0.4);
          box-shadow: 0 0 0 3px rgba(52,211,153,0.07);
        }

        .wa-input::placeholder { text-transform: none; font-weight: 400; color: var(--text-tertiary); font-size: 12px; letter-spacing: 0; }

        .wa-type-toggle {
          display: flex; border: 1px solid var(--border-subtle); border-radius: 8px; overflow: hidden; flex-shrink: 0;
        }

        .wa-type-btn {
          padding: 8px 14px; background: transparent; border: none; cursor: pointer;
          font-family: var(--font-mono); font-size: 12px; color: var(--text-tertiary);
          letter-spacing: 0.04em; transition: all 0.15s; white-space: nowrap;
        }

        .wa-type-btn + .wa-type-btn { border-left: 1px solid var(--border-subtle); }

        .wa-type-btn.active {
          background: rgba(52,211,153,0.1); color: var(--accent);
        }

        .wa-add-btn {
          background: var(--accent); color: var(--accent-ink); border: none; cursor: pointer;
          font-family: var(--font-mono); font-size: 12px; font-weight: 700;
          padding: 9px 18px; border-radius: 8px; white-space: nowrap; flex-shrink: 0;
          transition: background 0.15s, transform 0.15s;
          letter-spacing: 0.04em;
        }

        .wa-add-btn:hover:not(:disabled) { background: var(--accent-hover); transform: translateY(-1px); }
        .wa-add-btn:disabled { opacity: 0.4; cursor: not-allowed; }

        .wa-threshold-row {
          display: flex; align-items: center; gap: 10px; margin-top: 12px; flex-wrap: wrap;
        }

        .wa-threshold-label {
          font-size: 12px; color: var(--text-tertiary); font-weight: 400; white-space: nowrap;
        }

        .wa-direction-toggle {
          display: flex; border: 1px solid var(--border-subtle); border-radius: 6px; overflow: hidden;
        }

        .wa-dir-btn {
          padding: 5px 12px; background: transparent; border: none; cursor: pointer;
          font-family: var(--font-mono); font-size: 12px; color: var(--text-tertiary);
          transition: all 0.15s;
        }

        .wa-dir-btn + .wa-dir-btn { border-left: 1px solid var(--border-subtle); }
        .wa-dir-btn.active { background: rgba(52,211,153,0.1); color: var(--accent); }

        .wa-pct-wrap { display: flex; align-items: center; gap: 4px; }

        .wa-pct-input {
          width: 64px; background: var(--bg); border: 1px solid var(--border-subtle);
          border-radius: 6px; padding: 5px 10px;
          font-family: var(--font-mono); font-size: 13px; color: var(--text-primary);
          outline: none; transition: border-color 0.2s;
        }

        .wa-pct-input:focus { border-color: rgba(52,211,153,0.4); }
        .wa-pct-suffix { font-family: var(--font-mono); font-size: 13px; color: var(--text-tertiary); }
        .wa-error { font-size: 12px; color: var(--negative); margin-top: 10px; font-weight: 400; }

        /* ── Autocomplete ── */
        .wa-autocomplete-wrap { flex: 1; min-width: 120px; position: relative; }

        .wa-dropdown {
          position: absolute; top: calc(100% + 4px); left: 0; right: 0; z-index: 100;
          background: var(--surface-1); border: 1px solid var(--border-subtle); border-radius: 8px;
          overflow: hidden; box-shadow: 0 8px 24px rgba(0,0,0,0.4);
        }

        .wa-suggestion {
          display: block; width: 100%; text-align: left; padding: 9px 14px;
          background: transparent; border: none; cursor: pointer;
          font-family: var(--font-mono); font-size: 13px; font-weight: 500;
          color: var(--text-primary); letter-spacing: 0.06em;
          border-bottom: 1px solid var(--border-subtle); transition: background 0.1s;
        }

        .wa-suggestion:last-child { border-bottom: none; }
        .wa-suggestion:hover { background: rgba(52,211,153,0.06); color: var(--accent); }

        /* ── Preview card ── */
        .wa-preview {
          margin-top: 12px; background: var(--bg); border: 1px solid var(--border-subtle);
          border-radius: 8px; overflow: hidden;
        }

        .wa-preview-loading {
          display: flex; align-items: center; gap: 10px;
          padding: 14px 16px; font-size: 12px; color: var(--text-tertiary); font-weight: 400;
        }

        .wa-preview-spinner {
          width: 14px; height: 14px; border: 1.5px solid var(--border-subtle);
          border-top-color: var(--accent); border-radius: 50%;
          animation: spin 0.7s linear infinite; flex-shrink: 0;
        }

        .wa-preview-header {
          display: flex; align-items: center; gap: 10px;
          padding: 12px 16px; border-bottom: 1px solid var(--border-subtle);
        }

        .wa-preview-ticker {
          font-family: var(--font-mono); font-size: 14px; font-weight: 700; color: var(--text-primary);
        }

        .wa-preview-meta {
          font-family: var(--font-mono); font-size: 12px; color: var(--text-tertiary);
          letter-spacing: 0.03em;
        }

        .wa-preview-stats {
          display: grid; grid-template-columns: repeat(3, 1fr); gap: 1px;
          background: var(--border-subtle);
        }

        .wa-preview-stat {
          display: flex; flex-direction: column; gap: 3px;
          padding: 10px 14px; background: var(--bg);
        }

        .wa-preview-stat-label {
          font-family: var(--font-mono); font-size: 12px; color: var(--text-tertiary);
          text-transform: uppercase; letter-spacing: 0.1em;
        }

        .wa-preview-stat-val {
          font-family: var(--font-mono); font-size: 13px; font-weight: 700; color: var(--text-primary);
        }

        .wa-threshold-hint {
          font-size: 12px; color: var(--text-tertiary); font-weight: 400;
        }

        /* ── List ── */
        .wl-list { padding: 8px 0; }

        .wl-group { border-bottom: 1px solid var(--border-subtle); }
        .wl-group:last-child { border-bottom: none; }

        /* ── Item ── */
        .wi-row {
          display: flex; align-items: center; gap: 12px;
          padding: 13px 20px;
          transition: background 0.12s;
        }

        .wi-row:hover { background: rgba(255,255,255,0.015); }

        .wi-ticker {
          font-family: var(--font-mono); font-size: 14px; font-weight: 700;
          color: var(--text-primary); min-width: 52px; flex-shrink: 0;
        }

        .wi-meta { flex: 1; display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }

        .wi-badge {
          font-family: var(--font-mono); font-size: 12px; padding: 3px 10px;
          border-radius: 100px; border: 1px solid; white-space: nowrap; letter-spacing: 0.04em;
        }

        .wi-badge-conviction {
          color: var(--accent); background: rgba(52,211,153,0.08); border-color: rgba(52,211,153,0.2);
        }

        .wi-badge-upside {
          color: var(--neutral); background: rgba(251,191,36,0.08); border-color: rgba(251,191,36,0.2);
        }

        .wi-last-notified {
          font-family: var(--font-mono); font-size: 12px; color: var(--text-tertiary);
          letter-spacing: 0.03em;
        }

        .wi-remove-btn {
          width: 28px; height: 28px; border-radius: 6px; border: 1px solid var(--border-subtle);
          background: transparent; color: var(--text-tertiary); cursor: pointer; font-size: 18px;
          display: flex; align-items: center; justify-content: center; flex-shrink: 0;
          transition: all 0.15s; line-height: 1;
        }

        .wi-remove-btn:hover:not(:disabled) {
          border-color: rgba(248,113,113,0.3); color: var(--negative);
          background: rgba(248,113,113,0.06);
        }

        .wi-remove-btn:disabled { opacity: 0.3; cursor: not-allowed; }

        /* ── Empty/loading states ── */
        .wl-state {
          display: flex; flex-direction: column; align-items: center;
          gap: 12px; padding: 48px 0;
        }

        .wl-spinner {
          width: 22px; height: 22px; border: 2px solid var(--border-subtle);
          border-top-color: var(--accent); border-radius: 50%;
          animation: spin 0.7s linear infinite;
        }

        @keyframes spin { to { transform: rotate(360deg); } }

        .wl-state-label {
          font-family: var(--font-mono); font-size: 12px;
          color: var(--text-tertiary); letter-spacing: 0.08em; text-transform: uppercase;
        }

        .wl-error {
          padding: 16px 20px; font-size: 13px; color: var(--negative); font-weight: 400;
        }

        .wl-empty {
          display: flex; flex-direction: column; align-items: center;
          text-align: center; padding: 56px 24px;
        }

        .wl-empty-icon {
          width: 44px; height: 44px; border-radius: 10px;
          border: 1px solid var(--border-subtle); background: var(--surface-2);
          display: flex; align-items: center; justify-content: center;
          margin-bottom: 14px; color: var(--text-tertiary);
        }

        .wl-empty-title {
          font-family: var(--font-mono); font-size: 12px; color: var(--text-tertiary);
          letter-spacing: 0.06em; text-transform: uppercase; margin-bottom: 6px;
        }

        .wl-empty-sub {
          font-size: 13px; color: var(--text-tertiary); font-weight: 400;
          line-height: 1.65; max-width: 320px;
        }

        /* ── Pipeline notifications card ── */
        .pn-card {
          display: flex; align-items: center; justify-content: space-between; gap: 16px;
          background: var(--surface-1); border: 1px solid var(--border-subtle); border-radius: 12px;
          padding: 18px 20px;
        }

        .pn-left { display: flex; align-items: flex-start; gap: 14px; flex: 1; }

        .pn-icon {
          width: 36px; height: 36px; border-radius: 8px; background: rgba(52,211,153,0.07);
          border: 1px solid rgba(52,211,153,0.15); display: flex; align-items: center;
          justify-content: center; flex-shrink: 0; margin-top: 1px;
        }

        .pn-title {
          font-size: 14px; font-weight: 500; color: var(--text-primary); margin-bottom: 4px;
        }

        .pn-desc {
          font-size: 12px; color: var(--text-tertiary); line-height: 1.6; font-weight: 400;
        }

        /* Toggle switch */
        .pn-toggle {
          width: 44px; height: 24px; border-radius: 12px; border: none; cursor: pointer;
          background: var(--border-subtle); position: relative; flex-shrink: 0;
          transition: background 0.2s; outline: none;
        }

        .pn-toggle.pn-toggle-on { background: var(--accent); }
        .pn-toggle:disabled { opacity: 0.4; cursor: not-allowed; }

        .pn-toggle-knob {
          position: absolute; top: 3px; left: 3px;
          width: 18px; height: 18px; border-radius: 50%; background: #fff;
          transition: transform 0.2s; display: block;
        }

        .pn-toggle-on .pn-toggle-knob { transform: translateX(20px); }

        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(14px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        @media (max-width: 500px) {
          .wp-inner { padding: 36px 16px 60px; }
          .wa-row { flex-direction: column; align-items: stretch; }
          .wa-type-toggle { width: 100%; }
          .wa-type-btn { flex: 1; text-align: center; }
          .wa-add-btn { width: 100%; text-align: center; padding: 12px; }
          .pn-card { flex-direction: column; align-items: flex-start; gap: 14px; }
        }
      `}</style>

      <div className="wp-root">
        <PageBackdrop />

        <div className="wp-inner">
          {/* Header */}
          <div className="wp-header">
            <PageHeader
              eyebrow="Watchlist"
              title={
                <>
                  Track the stocks
                  <br />
                  that <em>matter</em> to you.
                </>
              }
              description="Get alerted when conviction changes or upside crosses your threshold."
            />
          </div>

          {/* Watchlist */}
          <div className="wp-section">
            <p className="wp-section-label">Your watchlist</p>
            <WatchlistList />
          </div>

          {/* Notifications */}
          <div className="wp-section">
            <p className="wp-section-label">Email preferences</p>
            <PipelineNotifications />
          </div>
        </div>
      </div>
    </>
  );
};

export default WatchlistPage;
